import {
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
    output,
    untracked,
    ViewEncapsulation,
    linkedSignal,
} from "@angular/core";
import { TypeManagerDecorator } from "../../../main/type.map.service";

@TypeManagerDecorator("generic-table-simple-select")
@Component({
    selector: "generic-table-simple-select",
    template: `
        <div class="select-wrapper" [class.has-error]="errorMsg()">
            @if (!isLoading()) {
                <select
                    [ngModel]="workingValue()"
                    (ngModelChange)="onUpdate($event)"
                    class="cn-form__control"
                    [attr.aria-label]="ariaLabel() || null"
                >
                    @for (option of options(); track option.value) {
                        <option [value]="option.value" [disabled]="!!option.disabled">{{ option.label }}</option>
                    }
                </select>
                @if (errorMsg()) {
                    <p class="error-message">{{ errorMsg() }}</p>
                } @else if (infoMsg()) {
                    <p class="ngFinePrint">{{ infoMsg() }}</p>
                }
            } @else {
                <s25-ng-loading-inline-static />
            }
        </div>
    `,
    styles: `
        ::ng-deep .nm-party--on .error-message {
            color: var(--color--danger);
        }

        ::ng-deep body#s25.nm-party--on .has-error select.cn-form__control,
        body.nm-party--on .has-error select.cn-form__control,
        html.nm-party--on .has-error select.cn-form__control {
            border-bottom-color: var(--color--danger) !important;
        }

        .select-wrapper {
            display: flex;
            flex-direction: column;
        }

        .has-error {
            position: relative;
            top: 11px;
            margin-bottom: 5px;
        }

        .has-error select {
            border-bottom: 2px solid var(--color--danger) !important;
        }

        .error-message {
            color: var(--color--danger);
            font-size: 0.8rem;
            text-wrap: nowrap;
        }

        s25-loading-inline {
            margin: 0;
        }

        .ngFinePrint {
            max-width: 20em;
        }
    `,
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class GenericTableSimpleSelectComponent {
    // TODO: convert modelValue to a `model` input
    readonly modelValue = input<string | number | undefined>(undefined);
    readonly options = input<{ value: string | number; label: string; disabled?: boolean }[] | undefined>(undefined);
    readonly resetAfterSelection = input<boolean>(false);
    readonly errorMsg = input<string>("");
    readonly infoMsg = input<string>("");
    readonly isLoading = input(false);
    readonly ariaLabel = input("");

    readonly modelValueChange = output<string | number | undefined>();

    protected readonly workingValue = linkedSignal(this.modelValue);

    onUpdate(value: string | number | undefined) {
        this.workingValue.set(value);
        this.modelValueChange.emit(value);
        if (this.resetAfterSelection()) {
            setTimeout(() => {
                this.workingValue.set(this.modelValue());
            }, 1000);
        }
    }
}
